const Errors = {
  SERVER_UNAVAILABLE:
    "Ocurrió un error en la petición, por favor intenta nuevamente.",
};

const IdentifierType = {
  DNI: {key: 1, label: 'D.N.I.'},
  RUC: {key: 6, label: 'R.U.C.'},
  CE: {key: 4, label: 'C.E.'},
  PASSPORT: {key: 7, label: 'Pasaporte'}
}

const ReportTypeValues = {
  COMPLAINT: { key: 1, label: "QUEJA" },
  CLAIM: { key: 2, label: "RECLAMO" },
};

const IsUnderage = {
  NOT: { key: 0, label: "NO" },
  YES: { key: 1, label: "SI" },
};

const ConfigLogoDimensions = {
  width: 272,
  height: 90,
};

const BrandsStatus = {
  ACTIVE: { key: 1, label: "ACTIVO", color: "badge-green" },
  INACTIVE: { key: 2, label: "SUSPENDIDO", color: "badge-yellow" },
};

const UsersStatus = {
  ACTIVE: { key: 1, label: "ACTIVO", color: "badge-green", action: 'Suspender' },
  INACTIVE: { key: 2, label: "SUSPENDIDO", color: "badge-yellow", action: 'Activar' },
};

const ProfileTypes = {
  ADMIN: { key: "ADMINISTRATOR", label: "ADMINISTRADOR" },
  SUPERVISOR: { key: "SUPERVISOR", label: "SUPERVISOR" },
  SUPER_ADMINISTRATOR: { key: "SUPER_ADMINISTRATOR", label: "SUPER ADMINISTRADOR" },
  AFFILIATE: { key: "AFFILIATE", label: "AFILIADO" },
};

const VehicleStatus = {
  ACTIVE: { key: 1, label: "ACTIVO", color: "badge-green", action: 'Suspender' },
  INACTIVE: { key: 2, label: "SUSPENDIDO", color: "badge-yellow", action: 'Activar' },
};

const VehicleTypes = {
  SEDAN: { key: 1, label: "SEDÁN" },
  MINI_BUS: { key: 2, label: "MINI BUS" },
  SUV: { key: 3, label: "SUV" },
  VAN: { key: 4, label: "VAN" },
};

const VehicleProperty = {
  TRAVELCAB: { key: "OWNED", label: "Propio" },
  EXTERNAL: { key: "RENTED", label: "Alquilado" },
};

const VehicleBrands = [
  { key: "BAIC", label: "BAIC" },
  { key: "CHANGAN", label: "CHANGAN" },
  { key: "CHERY", label: "CHERY" },
  { key: "CHEVROLET", label: "CHEVROLET" },
  { key: "DFSK", label: "DFSK" },
  { key: "DONGFENG", label: "DONGFENG" },
  { key: "FIAT", label: "FIAT" },
  { key: "GEELY", label: "GEELY" },
  { key: "GREAT WALL MOTORS (GWM)", label: "GREAT WALL MOTORS (GWM)" },
  { key: "HYUNDAI", label: "HYUNDAI" },
  { key: "JAC", label: "JAC" },
  { key: "JETOUR", label: "JETOUR" },
  { key: "KIA", label: "KIA" },
  { key: "MAZDA", label: "MAZDA" },
  { key: "MG", label: "MG" },
  { key: "NISSAN", label: "NISSAN" },
  { key: "RENAULT", label: "RENAULT" },
  { key: "SUZUKI", label: "SUZUKI" },
  { key: "TOYOTA", label: "TOYOTA" },
  { key: "VOLKSWAGEN", label: "VOLKSWAGEN" },
]

const DriverStatus = {
  ACTIVE: { key: 1, label: "ACTIVO", color: "badge-green", action: 'Suspender' },
  INACTIVE: { key: 2, label: "SUSPENDIDO", color: "badge-yellow", action: 'Activar' },
}

const LicenseTypesPeru = {
  A_I: { key: 1, label: "A-I" }, // vehículos particulares: sedán, SUV, pickup, furgón… :contentReference[oaicite:1]{index=1}
  A_IIA: { key: 2, label: "A-IIa" }, // taxis, ambulancias, transporte público interprovincial, además de A-I :contentReference[oaicite:2]{index=2}
  A_IIB: { key: 3, label: "A-IIb" }, // microbús hasta 16 asientos (4t), minibús hasta 33 asientos (7t), suma A-I y A-IIa :contentReference[oaicite:3]{index=3}
  A_IIIA: { key: 4, label: "A-IIIa" }, // ómnibus urbanos, interurbanos, panorámicos, articulados; incluye A‑I, IIa, IIb :contentReference[oaicite:4]{index=4}
  A_IIIB: { key: 5, label: "A-IIIb" }, // camiones, volquetes, grúas, chasis cabinado, plataforma, etc.; incluye A-I, IIa, IIb :contentReference[oaicite:5]{index=5}
  A_IIIC: { key: 6, label: "A-IIIc" }, // categoría más completa: permite todas las anteriores :contentReference[oaicite:6]{index=6}

  B_I: { key: 7, label: "B-I" }, // triciclos no motorizados para transporte público de pasajeros :contentReference[oaicite:7]{index=7}
  B_IIA: { key: 8, label: "B-IIa" }, // bicimotos para pasajeros o carga :contentReference[oaicite:8]{index=8}
  B_IIB: { key: 9, label: "B-IIb" }, // motocicletas (2 ruedas) y sidecars; incluye B‑IIa :contentReference[oaicite:9]{index=9}
  B_IIC: { key: 10, label: "B-IIc" }, // mototaxis, trimotos; incluye B‑IIa y B‑IIb :contentReference[oaicite:10]{index=10}
};

const BlackListStatus = {
  ACTIVE: { key: 1, label: "ACTIVO", color: "badge-green", action: 'Suspender' },
  INACTIVE: { key: 2, label: "SUSPENDIDO", color: "badge-yellow", action: 'Activar' }
}

// Acciones de auditoría (DEF-ADM-023 §4.1). Los colores siguen la paleta de
// badges del admin; CREATE pasó de gris a verde y UPDATE de ámbar a azul para
// que el tipo de acción se distinga de un vistazo.
//
// Las cuatro de contraseña ya se escribían en el backend y no estaban aquí: sin
// entrada en este mapa la fila pintaba un badge vacío.
const AuditLogAction = {
  CREATE: { key: "CREATE", label: "CREACIÓN", color: "badge-green" },
  UPDATE: { key: "UPDATE", label: "EDICIÓN", color: "badge-blue" },
  DELETE: { key: "DELETE", label: "ELIMINACIÓN", color: "badge-red" },
  STATUS_CHANGE: { key: "STATUS_CHANGE", label: "CAMBIO ESTADO", color: "badge-yellow" },
  ASSIGN: { key: "ASSIGN", label: "ASIGNACIÓN", color: "badge-purple" },
  LOGIN: { key: "LOGIN", label: "SESIÓN", color: "badge-gray" },
  PASSWORD_CHANGE: { key: "PASSWORD_CHANGE", label: "CAMBIO CLAVE", color: "badge-gray" },
  PASSWORD_RESET: { key: "PASSWORD_RESET", label: "RESET CLAVE", color: "badge-gray" },
  PASSWORD_RESET_REQUEST: { key: "PASSWORD_RESET_REQUEST", label: "SOLICITÓ RESET", color: "badge-gray" },
  REGENERATE_PASSWORD: { key: "REGENERATE_PASSWORD", label: "REGENERÓ CLAVE", color: "badge-gray" },
}

// Secciones que escribe el backend, con su nombre legible. Se usa tanto para el
// desplegable de filtros como para la columna "Sección" de la tabla.
const AuditLogSection = {
  AFFILIATES: 'Afiliados',
  AIRPORTS: 'Aeropuertos',
  AUTH: 'Sesión',
  BASE_PRICES: 'Precios Base',
  BLACKLIST: 'BlackList',
  BOOKINGS: 'Viajes',
  BOOKING_ASSIGNMENTS: 'Asignaciones',
  CATEGORIES: 'Categorías',
  CITIES: 'Ciudades',
  COUNTRIES: 'Países',
  COUPONS: 'Cupones',
  DISTRICTS: 'Distritos',
  DOCUMENT_TYPES: 'Tipos de documento',
  DRIVERS: 'Conductores',
  DRIVER_APP: 'App Conductor',
  ENTITY_DOCUMENTS: 'Documentos',
  FLEET: 'Flota',
  IMPORT_LOGS: 'Importaciones',
  OTAS: 'OTAs',
  PASSENGERS: 'Pasajeros',
  PRICE_TYPES: 'Reglas de Cálculo',
  PROVIDERS: 'Proveedores',
  PROVIDER_EXTRAS: 'Extras de Proveedor',
  PROVIDER_FARES: 'Tarifas de Proveedor',
  SETTLEMENTS: 'Liquidaciones',
  USERS: 'Usuarios',
  VEHICLES: 'Vehículos',
  VEHICLE_TYPES: 'Tipos de Vehículo',
}

// Traducción de los campos del diff a nombre legible (DEF-ADM-023 §4.2). Lo que
// no esté aquí se muestra con el nombre de la columna, que sigue siendo
// entendible; la idea es cubrir lo que más aparece.
const AuditLogField = {
  // Viajes
  ride: 'Código', fecha: 'Fecha', hora: 'Hora', fuente: 'Fuente',
  tipo_viaje: 'Tipo de viaje', origen: 'Origen', destino: 'Destino',
  distrito_origen: 'Distrito origen', distrito_destino: 'Distrito destino',
  estado: 'Estado', estado_pago: 'Estado de pago', medio_pago: 'Medio de pago',
  nombres: 'Nombres', apellidos: 'Apellidos', celular: 'Celular',
  cant_pax: 'Pasajeros', cant_maletas: 'Maletas', tipo_vehiculo: 'Tipo de vehículo',
  precio: 'Precio', precio_final: 'Precio final', moneda: 'Moneda',
  conductor_id: 'Conductor', conductor_nombre: 'Conductor',
  vehiculo_id: 'Vehículo', vehiculo_placa: 'Placa',
  provider_id: 'Proveedor', provider_name: 'Proveedor', provider_type: 'Tipo de proveedor',
  provider_fare_amount: 'Tarifa del proveedor',
  cupon_code: 'Cupón', descuento_aplicado: 'Descuento',
  tipo_vuelo: 'Tipo de vuelo', num_vuelo: 'Número de vuelo',
  observaciones: 'Observaciones', tipo_pasajero: 'Tipo de pasajero',
  city_id: 'Ciudad', city_name: 'Ciudad', channel: 'Canal',
  source_type: 'Origen del registro', affiliate_id: 'Afiliado',
  motivo_non_show: 'Motivo de no-show',
  // Comunes
  status: 'Estado', is_active: 'Activo', full_name: 'Nombre',
  phone_number: 'Teléfono', email: 'Correo', document_number: 'Documento',
  license_plate: 'Placa', brand: 'Marca', model: 'Modelo', year: 'Año',
  contact_name: 'Contacto', business_name: 'Razón social', ruc: 'RUC',
  payment_frequency: 'Frecuencia de pago', commission: 'Comisión',
  driver_type: 'Tipo de conductor', vehicle_type_id: 'Tipo de vehículo',
  // Tarifario y liquidaciones
  base_amount: 'Precio base', settlement_status: 'Estado de liquidación',
  code: 'Código', description: 'Descripción', discount_value: 'Descuento',
  created_at: 'Creado', updated_at: 'Actualizado',

  // --- DEF-ADM-023b: módulos que se sumaron al diff ---
  // Afiliados
  name: 'Nombre', address: 'Dirección', contact_person: 'Persona de contacto',
  identifier_type: 'Tipo de documento', identifier_number: 'Número de documento',
  category_id: 'Categoría', hotel_type: 'Tipo de hotel',
  commission_type: 'Tipo de comisión', latitude: 'Latitud', longitude: 'Longitud',
  // Pasajeros
  country_of_residence: 'País de residencia', passenger_type: 'Tipo de pasajero',
  price_type_id: 'Lista de precios', discount_type: 'Tipo de descuento',
  source: 'Origen del registro',
  // Flota — gastos
  vehicle_id: 'Vehículo', driver_id: 'Conductor', shift_id: 'Turno',
  expense_type: 'Tipo de gasto', amount: 'Monto', currency: 'Moneda',
  expense_date: 'Fecha del gasto', payment_method: 'Medio de pago',
  reviewed_by: 'Revisado por', reviewed_at: 'Fecha de revisión',
  review_notes: 'Notas de revisión', reimbursement_date: 'Fecha de reembolso',
  invoice_photo_url: 'Factura', reimbursement_proof_url: 'Comprobante de reembolso',
  liters: 'Litros', odometer_km: 'Kilometraje',
  // Flota — lavados
  wash_date: 'Fecha de lavado', wash_type: 'Tipo de lavado',
  car_wash_name: 'Lavadero', cost: 'Costo', photo_url: 'Foto', notes: 'Notas',
  // Flota — mantenimientos
  maintenance_date: 'Fecha de mantenimiento', maintenance_type: 'Tipo de mantenimiento',
  workshop_name: 'Taller', workshop_address: 'Dirección del taller',
  workshop_phone: 'Teléfono del taller', next_maintenance_km: 'Próximo mantenimiento (km)',
  interval_km: 'Intervalo (km)',
  // Flota — alquileres
  period_start: 'Inicio del periodo', period_end: 'Fin del periodo',
  payment_date: 'Fecha de pago', proof_url: 'Comprobante',
  // Usuarios
  first_name: 'Nombres', last_name: 'Apellidos', mobile: 'Celular', role: 'Rol',
  must_change_password: 'Debe cambiar contraseña', password_changed: 'Contraseña cambiada',
  last_logged_in: 'Último ingreso',
  // Blacklist
  reason: 'Motivo',
  // Documentos
  applies_to: 'Aplica a', has_expiration: 'Tiene vencimiento',
  is_required: 'Obligatorio', alert_days_before: 'Aviso previo (días)',
  document_type_id: 'Tipo de documento', entity_type: 'Tipo de entidad',
  entity_id: 'Registro', file_url: 'Archivo', file_name: 'Nombre del archivo',
  issue_date: 'Fecha de emisión', expiration_date: 'Fecha de vencimiento',
  doc_status: 'Estado del documento', uploaded_by: 'Subido por',
  // Tarifas y extras de proveedor
  district_id: 'Distrito', route_type: 'Tipo de ruta', extra_type: 'Tipo de extra',
  booking_id: 'Viaje',
  bank_name: 'Banco', bank_account_number: 'Número de cuenta', bank_cci: 'CCI',
  phone: 'Teléfono', phone_secondary: 'Teléfono alterno', dni: 'DNI',
  // Liquidaciones
  settlement_code: 'Código de liquidación', total_trips: 'Viajes',
  total_fare_amount: 'Total tarifas', total_extras_amount: 'Total extras',
  deductions_amount: 'Descuentos', final_amount: 'Total a pagar',
  deduction_notes: 'Notas de descuento', payment_proof_url: 'Comprobante de pago',
  sent_at: 'Enviada', confirmed_at: 'Confirmada', paid_at: 'Pagada',
  confirmed_by_name: 'Confirmada por',
  // Importaciones
  user_email: 'Usuario', total_filas: 'Filas del archivo', procesadas: 'Procesadas',
  creadas: 'Creadas', duplicadas: 'Duplicadas', omitidas: 'Omitidas',
  errores: 'Errores',
  // Catálogos: ciudades, aeropuertos, países, tipos
  country_id: 'País', timezone: 'Zona horaria', iata_code: 'Código IATA',
  currency_symbol: 'Símbolo de moneda', capacity: 'Capacidad',
  max_baggage: 'Maletas máximas', calculation_type: 'Tipo de cálculo',
  formula: 'Fórmula', is_protected: 'Protegida',
  // Distritos (UBIGEO)
  ubigeo_inei: 'UBIGEO INEI', ubigeo_reniec: 'UBIGEO RENIEC',
  departamento: 'Departamento', provincia: 'Provincia', distrito: 'Distrito',
  capital: 'Capital', superficie_km2: 'Superficie (km²)', altitud_m: 'Altitud (m)',
}
const CommissionOptions = {
  PERCENTAGE: {
    key: 2,
    label: "Porcentaje"
  },
  FIXED_AMOUNT: {
    key: 1,
    label: "Monto Fijo"
  }
};

const AffiliateCategories = {
  HOTEL:         { key: 1, label: "Hotel" },
  RESTAURANT:    { key: 2, label: "Restaurante" },
  TRAVEL_AGENCY: { key: 3, label: "Agencia de viaje" },
  COMPANY:       { key: 4, label: "Empresa" },
};

const HotelTypes = {
  BOUTIQUE: { key: 1, label: "Boutique" },
  STANDARD: { key: 2, label: "Estándar" },
  RESORT:   { key: 3, label: "Resort" },
};

const AffiliateStatus = {
  ACTIVE: { key: 1, label: "ACTIVO", color: "badge-green", action: 'Suspender' },
  INACTIVE: { key: 2, label: "SUSPENDIDO", color: "badge-yellow", action: 'Activar' },
}

const PassengerIdentifierType = {
  DNI:      { key: 1, label: 'D.N.I.' },
  CE:       { key: 4, label: 'C.E.' },
  PASSPORT: { key: 7, label: 'Pasaporte' },
};

const PassengerType = {
  REGULAR:   { key: 1, label: "Regular" },
  FRECUENTE: { key: 4, label: "Frecuente" },
  VIP:       { key: 6, label: "VIP" },
};

const PassengerStatus = {
  ACTIVE: { key: 1, label: "ACTIVO", color: "badge-green", action: 'Suspender' },
  INACTIVE: { key: 2, label: "SUSPENDIDO", color: "badge-yellow", action: 'Activar' },
}

const VehicleTypeStatus = {
  ACTIVE: { key: 1, label: "ACTIVO", color: "badge-green", action: 'Suspender' },
  INACTIVE: { key: 2, label: "SUSPENDIDO", color: "badge-yellow", action: 'Activar' },
}

const CouponStatus = {
  ACTIVE: { key: true, label: "ACTIVO", color: "badge-green", action: 'Suspender' },
  INACTIVE: { key: false, label: "SUSPENDIDO", color: "badge-yellow", action: 'Activar' },
}

const DiscountTypeOptions = [
  { key: 'percent', label: 'Porcentaje (%)' },
  { key: 'fixed', label: 'Monto fijo' },
]

// El orden es el recorrido real de un viaje: la OTA liquida un lote y avisa
// que lo va a pagar en una fecha futura (Liquidado), y semanas despues paga.
// Liquidado es plata comprometida; Pendiente es la que nadie prometio todavia.
const RideEstadoPago = {
  PENDIENTE: { key: "Pendiente", label: "Pendiente" },
  LIQUIDADO: { key: "Liquidado", label: "Liquidado" },
  PAGADO:    { key: "Pagado",    label: "Pagado" },
  CANCELADO: { key: "Cancelado", label: "Cancelado" },
}

const RideMoneda = {
  SOLES:   { key: "SOLES",   label: "SOLES" },
  DOLARES: { key: "DOLARES", label: "DOLARES" },
}

// Medios de pago de un viaje (DEF-ADM-032).
//
// ⚠️ Hay una segunda copia de esta lista, escrita a mano como <option> en
// RideList.vue (el modal de registrar pago). No se unificó acá porque el
// DEF-ADM-032 pide expresamente no tocar la pantalla de Viajes. Cuando se
// toque ese archivo por otro motivo, reemplazar las opciones por un v-for
// sobre esta constante: dos listas de lo mismo se separan solas con el tiempo.
const RideMedioPago = {
  ELIFE:         { key: "ELIFE",         label: "ELIFE" },
  POLITTAN:      { key: "POLITTAN",      label: "POLITTAN" },
  VIATOR:        { key: "VIATOR",        label: "VIATOR" },
  LINK_DE_PAGO:  { key: "LINK DE PAGO",  label: "LINK DE PAGO" },
  TRANSFERENCIA: { key: "TRANSFERENCIA", label: "TRANSFERENCIA" },
  YAPE:          { key: "YAPE",          label: "YAPE" },
  PAGO_POS:      { key: "PAGO POS",      label: "PAGO POS" },
  EFECTIVO:      { key: "EFECTIVO",      label: "EFECTIVO" },
  CORPORATIVO:   { key: "CORPORATIVO",   label: "CORPORATIVO" },
  DESPEGAR:      { key: "DESPEGAR",      label: "DESPEGAR" },
  TRANSFERZ:     { key: "TRANSFERZ",     label: "TRANSFERZ" },
}

const RideTipoViaje = {
  APTO_HOT:  { key: "APTO-HOT",  label: "APTO-HOT" },
  HOT_APTO:  { key: "HOT-APTO",  label: "HOT-APTO" },
  DISTRITAL: { key: "DISTRITAL", label: "DISTRITAL" },
}

// DEF-ADM-018 — Proveedores de servicio.
const ProviderType = {
  ASOCIADO: { key: "ASOCIADO", label: "ASOCIADO", color: "badge-green" },
  TRANSPORTISTA: { key: "TRANSPORTISTA", label: "TRANSPORTISTA", color: "badge-yellow" },
};

const ProviderStatus = {
  ACTIVE: { key: 1, label: "ACTIVO", color: "badge-green", action: "Desactivar" },
  INACTIVE: { key: 2, label: "INACTIVO", color: "badge-yellow", action: "Activar" },
};

const PaymentFrequency = {
  DAILY: { key: "DAILY", label: "Diaria" },
  EVERY_2_DAYS: { key: "EVERY_2_DAYS", label: "Cada 2 días" },
  WEEKLY: { key: "WEEKLY", label: "Semanal" },
  BIWEEKLY: { key: "BIWEEKLY", label: "Quincenal" },
  MONTHLY: { key: "MONTHLY", label: "Mensual" },
};

// Tipo de conductor. TRANSPORTISTA_DRIVER no tiene acceso a la app.
const DriverType = {
  PROPIO: { key: "PROPIO", label: "PROPIO", color: "badge-blue" },
  ASOCIADO: { key: "ASOCIADO", label: "ASOCIADO", color: "badge-green" },
  TRANSPORTISTA_DRIVER: { key: "TRANSPORTISTA_DRIVER", label: "TRANSPORTISTA", color: "badge-yellow" },
};

// Tipo de proveedor de un viaje (bookings.provider_type). null = PROPIO.
const RideProviderType = {
  PROPIO: { key: "PROPIO", label: "Propio", short: "P", color: "badge-blue" },
  ASOCIADO: { key: "ASOCIADO", label: "Asociado", short: "A", color: "badge-green" },
  TRANSPORTISTA: { key: "TRANSPORTISTA", label: "Transportista", short: "T", color: "badge-yellow" },
};

// DEF-ADM-021 — Liquidaciones a proveedores.
const SettlementStatus = {
  DRAFT: { key: "DRAFT", label: "Borrador", color: "badge-gray" },
  SENT: { key: "SENT", label: "Enviada", color: "badge-blue" },
  CONFIRMED: { key: "CONFIRMED", label: "Confirmada", color: "badge-yellow" },
  PAID: { key: "PAID", label: "Pagada", color: "badge-green" },
};

// Estado de pago al proveedor de un viaje, para el badge de la lista de viajes.
// PENDING = tiene proveedor pero no está en ninguna liquidación.
const TripPaymentStatus = {
  PENDING: { key: "PENDING", label: "Pendiente", color: "badge-yellow" },
  DRAFT: { key: "DRAFT", label: "Borrador", color: "badge-gray" },
  SENT: { key: "SENT", label: "Enviada", color: "badge-blue" },
  CONFIRMED: { key: "CONFIRMED", label: "Confirmada", color: "badge-blue" },
  PAID: { key: "PAID", label: "Pagada", color: "badge-green" },
};

const SettlementPaymentMethod = {
  TRANSFERENCIA: { key: "TRANSFERENCIA", label: "Transferencia" },
  YAPE: { key: "YAPE", label: "Yape" },
  PLIN: { key: "PLIN", label: "Plin" },
  EFECTIVO: { key: "EFECTIVO", label: "Efectivo" },
  OTRO: { key: "OTRO", label: "Otro" },
};

// DEF-ADM-020 — Extras que se le pagan al proveedor por un viaje.
const ProviderExtraType = {
  PARKING: { key: "PARKING", label: "Parking" },
  WAITING: { key: "WAITING", label: "Espera" },
  TOLL: { key: "TOLL", label: "Peaje" },
  DIFFERENTIAL: { key: "DIFFERENTIAL", label: "Diferencial" },
  OTHER: { key: "OTHER", label: "Otro" },
};

// DEF-ADM-019 — Gestión documental.
// Entidad a la que aplica un tipo de documento.
const DocumentEntity = {
  VEHICLE: { key: "VEHICLE", label: "Vehículo", color: "badge-blue" },
  DRIVER: { key: "DRIVER", label: "Conductor", color: "badge-green" },
  PROVIDER: { key: "PROVIDER", label: "Proveedor", color: "badge-yellow" },
};

// Estado de un documento subido.
const DocumentStatus = {
  VALID: { key: "VALID", label: "Vigente", color: "badge-green" },
  EXPIRED: { key: "EXPIRED", label: "Vencido", color: "badge-red" },
  PENDING_REVIEW: { key: "PENDING_REVIEW", label: "Por revisar", color: "badge-gray" },
};

// Estado documental de una entidad en el dashboard de compliance.
const ComplianceStatus = {
  COMPLETE: { key: "COMPLETE", label: "Completo", color: "badge-green" },
  EXPIRING: { key: "EXPIRING", label: "Por vencer", color: "badge-yellow" },
  EXPIRED: { key: "EXPIRED", label: "Vencido", color: "badge-red" },
  INCOMPLETE: { key: "INCOMPLETE", label: "Incompleto", color: "badge-gray" },
};

const DocumentTypeStatus = {
  ACTIVE: { key: 1, label: "ACTIVO", color: "badge-green", action: "Desactivar" },
  INACTIVE: { key: 2, label: "INACTIVO", color: "badge-yellow", action: "Activar" },
};

export default {
  Errors,
  IdentifierType,
  ProviderExtraType,
  SettlementStatus,
  SettlementPaymentMethod,
  TripPaymentStatus,
  DocumentEntity,
  DocumentStatus,
  DocumentTypeStatus,
  ComplianceStatus,
  ProviderType,
  ProviderStatus,
  PaymentFrequency,
  DriverType,
  RideProviderType,
  ReportTypeValues,
  IsUnderage,
  ConfigLogoDimensions,
  UsersStatus,
  BrandsStatus,
  ProfileTypes,
  VehicleTypes,
  VehicleProperty,
  LicenseTypesPeru,
  VehicleStatus,
  VehicleBrands,
  DriverStatus,
  CommissionOptions,
  AffiliateCategories,
  HotelTypes,
  AffiliateStatus,
  PassengerIdentifierType,
  PassengerType,
  BlackListStatus,
  AuditLogAction,
  AuditLogSection,
  AuditLogField,
  PassengerStatus,
  VehicleTypeStatus,
  CouponStatus,
  DiscountTypeOptions,
  RideEstadoPago,
  RideMedioPago,
  RideMoneda,
  RideTipoViaje,
};
